import * as React from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import { marked } from "marked";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Button, TextField } from "@mui/material";

import { downloadFile, downloadGcsFile } from "./api";

export default function DownloadButton(props) {
  const { citations } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [fileType, setFileType] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [fileName, setfileName] = React.useState("");

  const handleClick = (event) => {
    setfileName(props.document_name);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setfileName(props.document_name);
    if (props.handleNextClose) {
      props.handleNextClose();
    }
  };
  const handleDownload = async () => {
    setLoading(true);
    if (props.gcs_url) {
      setfileName(props.document_name);
      await downloadGcsFile(props.gcs_url, fileType, fileName);
    } else {
      let html_code = marked(props.download_text);
      if (props.citations && props.citations.length > 0) {
        const citationsText = props.citations
          .map((citation, index) => {
            const fileName = citation.source.split("/").pop();
            return `<p><strong>Reference ${index + 1}:</strong> ${fileName}</p>`;
          })
          .join("");

        html_code += `<h3>Sources</h3>${citationsText}`;
      }
      if (!html_code.includes("<table>") && fileType != "docx") {
        html_code = " <table><tr><th>" + html_code + "</th></tr></table>";
      }
      await downloadFile(html_code, fileType, fileName);
    }

    handleClose();
    setLoading(false);
    if (props.handleNext) {
      props.handleNext();
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "2px ",
    boxShadow: 24,
    p: 4,
  };

  React.useEffect(() => {
    setfileName(props.document_name);
  }, [props.document_name]);

  return (
    <div>
      <Button
        sx={{ textTransform: "capitalize", fontSize: "1rem" }}
        disabled={
          (!props.download_text && !props.gcs_url) ||
          props.loading ||
          props.covloader
        }
        variant="contained"
        startIcon={<FileDownloadIcon />}
        onClick={handleClick}
      >
        Download
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
            marginTop: "50px",
          }}
        >
          <Box sx={style}>
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              id="outlined-basic"
              label="Document Name"
              variant="outlined"
              value={fileName}
              onChange={(e) => setfileName(e.target.value)}
            />
            <FormControl
              variant="outlined"
              style={{ minWidth: 200, display: "flex" }}
            >
              <InputLabel id="file-type-label">Select File Type</InputLabel>
              <Select
                labelId="file-type-label"
                value={fileType}
                onChange={(e) => setFileType(e.target.value)}
                label="Select File Type"
              >
                <MenuItem value="pdf">PDF</MenuItem>
                <MenuItem value="xlsx">Excel (XLSX)</MenuItem>
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="docx">Docx</MenuItem>
              </Select>
            </FormControl>

            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 3,
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Button
                disabled={fileType === "" || fileName === ""}
                style={{ margin: "15px calc(100% - 100px)", width: "100px" }}
                variant="contained"
                color="primary"
                onClick={handleDownload}
              >
                Download
              </Button>
            )}
          </Box>
        </div>
      </Modal>
    </div>
  );
}
